module.exports = __webpack_public_path__ + "img/reel2.881606ed.webp";